export default __webpack_public_path__ + "static/media/student.42a51c1c.svg";